import { gql } from '@apollo/client'

export const TOPOLOGY_BY_SITE = gql`
  query TopologyBySite($sf_id: String!, $hotspot_id: ID) {
    topology: topologyBySite(sf_id: $sf_id, hotspot_id: $hotspot_id)
  }
`

export const HOTSPOTS_BY_SITE = gql`
  query HotspotsBySite($sf_id: String!) {
    hotspots: hotspotsBySite(sf_id: $sf_id) {
      id
      name
    }
  }
`
